import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Review } from '../../../../models/review.model';
import { ReviewSidebarComponent } from '../../../../web/components/review-sidebar/review-sidebar.component';
import { Partner } from '../../../../models/partner.model';
import { ScreenSizeService } from '../../../../../services/utils/screenSize.service';
import { ReviewDetailsComponent } from '../../../../web/components/review-details/review-details.component';
import { OpenWriteReviewModalService } from '../../../../../services/openWriteReviewModal.service';
import { ViewStatus } from '@uranda/ui';
import { ModalOffcanvasService } from '../../../../../services/modal-offcanvas.service';
import { OffcanvasHistoryService } from '../../../../../services/offcanvas-history.service';

@Component({
    selector: 'app-swiper',
    templateUrl: './swiper.component.html',
    styleUrls: ['./swiper.component.css'],
    standalone: false
})
export class SwiperComponent implements OnInit {
  @Input() reviews?: Review[];
  @ViewChild('mySwiper', { static: false }) swiperRef!: ElementRef;
  @Input() partner?: Partner;
  @Input() viewStatus = ViewStatus.READY;
  ViewStatus = ViewStatus;
  isPrevDisabled = true;
  isNextDisabled = false;
  isLast = false;
  @Input() forceOffcanvas = false;
  constructor(
    protected screenSizeService: ScreenSizeService,
    private openWriteReviewModalService: OpenWriteReviewModalService,
    private modalOffcanvasService: ModalOffcanvasService,
    private offcanvasHistory: OffcanvasHistoryService
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.updateArrowState();
      if (this.swiperRef && this.swiperRef.nativeElement.swiper) {
        this.swiperRef.nativeElement.swiper.on('slideChange', () => {
          this.updateArrowState();
        });
      }
    }, 0);
  }

  prev() {
    this.swiperRef.nativeElement.swiper.slidePrev();
  }

  next() {
    this.swiperRef.nativeElement.swiper.slideNext();
  }

  updateArrowState() {
    if (!this.swiperRef?.nativeElement?.swiper) return;

    const swiper = this.swiperRef.nativeElement.swiper;
    const activeIndex = swiper.activeIndex;
    const totalSlides = this.reviews ? this.reviews.length : 0;
    const slidesPerView = swiper.params.slidesPerView as number;

    this.isPrevDisabled = activeIndex === 0;
    this.isNextDisabled = activeIndex >= totalSlides - slidesPerView;
  }

  openReviewsOffcanvas() {

    const offcanvasRef = this.offcanvasHistory.open(ReviewSidebarComponent, {
      position: 'end',
      scroll: false,
      backdrop: true,
      panelClass: 'reviews-offcanvas-panel',
    });

    offcanvasRef.componentInstance.partnerId = this.partner?.id;
    offcanvasRef.componentInstance.clinicName = this.partner?.name;
    offcanvasRef.componentInstance.averageRating = this.partner?.averageRate;
    offcanvasRef.componentInstance.totalReviews = this.partner?.reviewsCount;
    offcanvasRef.componentInstance.reviews = this.reviews;
    offcanvasRef.result.then(() => {
      document.body.style.overflow = 'hidden';
    });
  }

  openWriteReviewModal() {
    if (!this.partner) return;

    const partnerInfo = {
      id: this.partner.id,
      name: this.partner.name
    };

    this.openWriteReviewModalService.openWriteReviewModal(partnerInfo)
  }

  reviewDetails(review: Review) {
    this.modalOffcanvasService.openComponent(ReviewDetailsComponent, {
      review: review,
      isOffcanvas: this.screenSizeService.isMobile || this.forceOffcanvas
    }, undefined, this.forceOffcanvas);
  }
}